export default __webpack_public_path__ + "static/media/trabajo.f4212cfa.png";